






































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { mapGetters } from 'vuex';
import { Route } from 'vue-router/types/router';

import { categoryIdForAnswerSlug, withPreservedQueryParams } from 'frontend/views/nux/common';
import NuxStep from 'frontend/views/nux/components/NuxStep.vue';
import NuxStepMedia from 'frontend/views/nux/components/NuxStepMedia.vue';
import NuxStepSurvey from 'frontend/views/nux/components/NuxStepSurvey.vue';
import { FeatureSwitches, PrivacyProperties } from 'frontend/types';
import {
  PossibleAnswerSlug,
  PossibleCategoryId,
  SegmentationAnswerInput,
} from 'frontend/types/segmentation';
import { quantcastTrack, tatariTrack } from 'frontend/utils/analytics';
import { postData } from 'frontend/utils/ajax';
import { trackClickWithElementId } from 'frontend/utils/nux';
import { MARKETING_LANDING_PAGES_GET_PARAM } from 'frontend/utils/marketing';
import { stringifyQueryParams } from 'frontend/utils/urls';
import { onboardingFlowId } from 'frontend/components/util/Savvy/SavvyConstants';
import SavvyFlow from 'frontend/components/util/Savvy/SavvyFlow.vue';
import SegmentationQuestionMixin from './mixins/SegmentationQuestionMixin';
import { ChoiceIdentifier, SavvyAnswerChoice } from 'frontend/types/nux';

@Component({
  components: {
    NuxStepSurvey,
    NuxStepMedia,
    NuxStep,
    SavvyFlow,
  },
  computed: {
    ...mapGetters('globals', ['privacyProperties', 'featureSwitches']),
  },
  metaInfo(): { title: string } {
    return {
      title: 'Welcome',
    };
  },
})
export default class UserWelcome extends mixins(SegmentationQuestionMixin) {
  featureSwitches!: FeatureSwitches;
  answeredTrackId = 'clicked_nux_goal_continue';
  private privacyProperties!: PrivacyProperties;
  private formSubmitted = false;
  private selectedCategoryId = -1;

  get isSavvyEnabled(): boolean {
    return !!this.featureSwitches.enable_savvy_onboarding_flow;
  }

  get onboardingFlowId(): string {
    return onboardingFlowId;
  }

  get questionText(): string {
    if (this.isReturningUser) {
      return 'Welcome back! Has your learning goal changed?';
    }
    return this.segmentationQuestion.text;
  }

  get questionSubtext(): string {
    if (this.isReturningUser) {
      return 'Confirm your goal to help us create the best learning experience.';
    }
    return this.segmentationQuestion.subtext || '';
  }

  get disableContinueButton(): boolean {
    return this.choice.size === 0;
  }

  mounted(): void {
    if (!this.privacyProperties.under_17) {
      quantcastTrack('Signup');
      tatariTrack('sign_up');
    }
  }

  async navigateTo(route: string): Promise<Route> {
    return await this.$router.push(
      withPreservedQueryParams(this.$route, { name: route }, [
        MARKETING_LANDING_PAGES_GET_PARAM,
        'do_re_nux',
      ]),
    );
  }

  get nextRoute(): string {
    if (this.isReturningUser) {
      return 'nux_welcome_product_reason_two';
    }
    return 'nux_welcome_product_reason_one';
  }

  selectAnswer(selection: ChoiceIdentifier): void {
    this.selectChoice(selection);
    this.selectedCategoryId = this.selectLegacyUserCategoryForAnswerSlug(selection);
  }

  async postUsersAnswer(): Promise<void> {
    const answerSlugs = Array.from(this.choice).join(',');
    const query: SegmentationAnswerInput = {
      segmentation_answer_slug: answerSlugs,
      segmentation_question_slug: this.segmentationQuestion.slug,
      user_category_id: this.selectedCategoryId,
    };
    trackClickWithElementId(`clicked_nux_goal_${answerSlugs}`);
    await postData(this.$route.path, stringifyQueryParams(query));
  }

  selectLegacyUserCategoryForAnswerSlug(answerSlug: ChoiceIdentifier): PossibleCategoryId {
    return categoryIdForAnswerSlug[answerSlug as PossibleAnswerSlug];
  }

  saveAnswer(segmentationQuestionSlug: string, segmentationAnswerSlug: SavvyAnswerChoice): void {
    // Multiple answers question send in an Array of answers
    // single answer question send in a string
    const segmentationAnswerChoice: string = Array.isArray(segmentationAnswerSlug)
      ? segmentationAnswerSlug.join(',')
      : segmentationAnswerSlug;

    const segmentationAnswer = {
      segmentation_question_slug: segmentationQuestionSlug,
      segmentation_answer_slug: segmentationAnswerChoice.replaceAll('_', '-'),
    };

    postData('/api/v4/segmentation/answer', segmentationAnswer);
  }
}
